import { assign, object, optional, partial } from 'superstruct';
import { PaginationQueryDefaulted, SortQuery } from '@arc/shared/util-data';
import { searchString } from '@arc/shared/util-superstruct';
import { CleanupTaskFilterQueryDto } from './cleanup-task-filter.dto';
const CLEANUP_TASK_SORTABLE_FIELDS = ['resourceName', 'resourceType', 'status', 'deleteAt', 'createdAt'];
export const ListCleanupTaskQueryDto = assign(PaginationQueryDefaulted(), SortQuery(CLEANUP_TASK_SORTABLE_FIELDS), object({
  search: searchString(),
  filter: optional(partial(CleanupTaskFilterQueryDto))
}));
export const defaultCleanupTaskSort = {
  sort: 'deleteAt',
  sortDirection: 'asc'
};